import moment from 'moment'

// --- Error message constants ---
export const ERRORS = {
  REQUIRED_FIELDS: 'Please fill all required fields',
  DEPARTURE_AFTER_ARRIVAL: 'Departure date should be after arrival date',
  DEPARTURE_AFTER_TODAY: 'Departure date should be after today',
  PHONE_FORMAT: 'Wrong phone format, country code is required',
  RENTAL_OVERLAP: 'An existing rental overlaps with dates',
  TIMEZONE_MISMATCH: 'Timezone does not correspond to address provided',
  IMAGE_REQUIRED: 'At least 1 photo is required to create a property'
}

/**
 * Returns true if value is non-null, non-undefined, and non-empty-string.
 */
export function required(value) {
  if (value === null || value === undefined) return false
  if (typeof value === 'string' && value.trim() === '') return false
  return true
}

/**
 * Returns true if value matches international phone format with country code.
 * E.g. +14155552671
 */
export function validPhone(value) {
  if (!value) return false
  const regex = /^(\+)[0-9]{1,3}[0-9]{4,14}$/
  return regex.test(value)
}

/**
 * Returns true if dateA is strictly before dateB (i.e. dateB is after dateA).
 * Used to check that departure is after arrival.
 */
export function dateAfter(dateA, dateB) {
  return moment(dateA).isBefore(moment(dateB))
}

/**
 * Returns true if date is on or after today (midnight-normalized).
 */
export function dateAfterToday(date) {
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  const target = new Date(date)
  target.setHours(0, 0, 0, 0)
  return target >= today
}

/**
 * Validates that all specified fields in the data object are present (non-null, non-undefined, non-empty).
 * @param {string[]} fields - Array of field names to check
 * @param {Object} data - Data object to validate against
 * @returns {{ valid: boolean, invalidFields: string[] }}
 */
export function validateFields(fields, data) {
  const invalidFields = fields.filter((field) => !required(data[field]))
  return {
    valid: invalidFields.length === 0,
    invalidFields
  }
}
